import { useOnMount } from '../index';
import type { RequestEvent, RequestEventEmitter } from './makeRequest';

/**
 * Subscribe to a RequestEventEmitter on mount with the passed in event handler function and un-subscribe on unmount.
 *
 * @deprecated - This pattern is outdated -- use useAsyncValue and friends (like useAsyncRequest) instead.
 */
const useRequestEvents = <Context>(
  emitter: RequestEventEmitter<Context>,
  handler: (event: RequestEvent<Context>) => void,
) => {
  useOnMount(
    () => emitter.subscribe(handler),
    () => emitter.unSubscribe(handler),
  );
};

export default useRequestEvents;
